var map = {
	"./1.png": 1558,
	"./2.png": 1559,
	"./3.png": 1560,
	"./4.png": 1561,
	"./5.png": 1562,
	"./6.png": 1563,
	"./7.png": 1564,
	"./8.png": 1565
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1557;